<div class="grid gap-2">
	<pre
		class="bg-neutral-800 text-white overflow-y-auto overflow-x-auto"
		[innerHTML]="data | prettyjson: []"></pre>
	<ms-button severity="success" label="OK" styleClass="w-full" (click)="onClose()"></ms-button>
</div>
